import { render } from "./setDiscountBlockDay.vue?vue&type=template&id=2d6745fa&scoped=true"
import script from "./setDiscountBlockDay.vue?vue&type=script&lang=js"
export * from "./setDiscountBlockDay.vue?vue&type=script&lang=js"

import "./setDiscountBlockDay.vue?vue&type=style&index=0&id=2d6745fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6745fa"]])

export default __exports__